import { Card } from 'antd';
import React from 'react';

type DetailCardProps = {
  children: React.ReactNode;
};

const DetailCard = ({ children }: DetailCardProps) => {
  return (
    <Card
      styles={{
        body: {
          padding: '20px 20px 12px',
          border: '1px solid #E9EEF4',
          borderRadius: 8,
        },
      }}
      style={{
        border: 'none',
        marginBottom: 10,
      }}
    >
      {children}
    </Card>
  );
};

export default DetailCard;
